import React from "react";

import { Flex, Icon, Image } from "@chakra-ui/react";
import { BsCircleFill } from "react-icons/bs";

import iconAprobada from "assets/images/icon-aprobadas.svg";
import iconContestada from "assets/images/icon-contestadas.svg";
import iconEnviada from "assets/images/icon-enviadas.svg";
import iconVista from "assets/images/icon-vistas.svg";
import { ActivoCompletoOutput } from "components/Portfolio/types/activos";

export const ADIF_RED = "#E53E3E";

export const ESTADO_COMUNICACION_CONFIG: Record<string, { label: string; color: string; icon: string }> = {
	enviada: { label: "Enviada", color: "#E2E8F0", icon: iconEnviada },
	vista: { label: "Vista", color: "#43B3EA", icon: iconVista },
	contestada: { label: "Contestada", color: "#A76BC7", icon: iconContestada },
	aprobada: { label: "Finalizada", color: "#32A4A0", icon: iconAprobada },
};

export const EstadoComunicacionIndicator: React.FC<{ estado?: string }> = ({ estado }) => {
	const config = estado ? ESTADO_COMUNICACION_CONFIG[estado] : undefined;
	return (
		<Flex alignItems="center" justifyContent="center" boxSize="1.25rem">
			{config ? (
				<Image src={config.icon} alt={config.label} title={config.label} boxSize="100%" />
			) : (
				<Icon as={BsCircleFill} color="gray.200" fontSize="1.25rem" title="Sin comunicación" />
			)}
		</Flex>
	);
};

const isEmail = (value: string | undefined, email: string) => !!value && value.trim().toLowerCase() === email;

export const isRecipientPending = (asset: ActivoCompletoOutput, email: string) =>
	(asset.estado_comunicacion === "enviada" || asset.estado_comunicacion === "vista") &&
	!!asset.recipients?.some((recipient) => isEmail(recipient, email));

export const isIssuerPending = (asset: ActivoCompletoOutput, email: string) =>
	asset.estado_comunicacion === "contestada" && isEmail(asset.issuer, email);

export const isComunicacionPending = (asset: ActivoCompletoOutput, email: string) =>
	isRecipientPending(asset, email) || isIssuerPending(asset, email);
